// Base URLs
export const BASE_URL = 'https://pmis.mrbhn.com';
//export const BASE_URL = 'https://pmis.mrbhn.com';
export const API_URL = `${BASE_URL}/api`;
export const WSO2_URL = 'https://sso.mrbhn.com';
// export const WSO2_URL = 'https://sso.mrbhn.com';
export const FILE_BASE_URL = BASE_URL;
export const API_BASE_URL = API_URL;
export const FILES_SYSTEM_URL = 'https://files.mrbhn.com';
export const BIM_SYSTEM_URL = 'https://bim.mrbhn.com';
export const TASK_PROJECT_DASHBOARD_URL = '/task-project-dashboard';

// Auth URLs
export const AUTH_URL = `${API_URL}/auth`;
export const LOGIN_URL = `${AUTH_URL}/login`;
export const LOGOUT_URL = `${AUTH_URL}/logout`;
export const REFRESH_TOKEN_URL = `${AUTH_URL}/refresh-token`;

// Guide URLs
export const GUIDE_VIDEOS = {
  SSO_LOGIN: `${FILES_SYSTEM_URL}/index.php/s/Nbf89ZQ7qjHBxk4`,
  FILES_LOGIN: `${FILES_SYSTEM_URL}/index.php/s/teYJk97W76EYjke`,
  BACK_TO_FILES: `${FILES_SYSTEM_URL}/index.php/s/4BXEBr9CcBdC4Kc`
}; 